<template>
  <div>
    <request-applicant :request-object-key="requestObjectKey"></request-applicant>
    <request-owner
      :request-object-key="requestObjectKey"
      :request-owner-type-id="requestInfo.requestOwnerTypeId"
    ></request-owner>
    <activities
      v-if="isDebtor"
      :request-object-key="requestObjectKey"
    ></activities>
    <secretary-info
      v-if="showSecretaryInfoSection"
      :request-object-key="requestObjectKey"
      :request-info="requestInfo"
    ></secretary-info>
  </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');
import RequestApplicant from './request-applicant';
import SecretaryInfo from './secretary-info';
import Activities from './activities';
import RequestOwner from './request-owner';
import { requestOwnerTypeEnum, legalCapacitiesEnum, procedureTypeEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  name: 'BasicInfoTab',
  components: {
    RequestApplicant,
    RequestOwner,
    Activities,
    SecretaryInfo,
  },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
    requestInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      basicInfoLocal: this.local.bankruptcy.bankruptcyFile.basicInfo,
    };
  },
  computed: {
    isDebtor() {
      return this.requestInfo && this.requestInfo.requestOwnerTypeId == requestOwnerTypeEnum.debtor;
    },
    procedureType() {
      return this.requestInfo.openedProcedureId || this.requestInfo.procedureTypeId;
    },
    showSecretaryInfoSection() {
      return this.requestInfo && this.requestInfo.legalCapacityId != legalCapacitiesEnum.bankruptcySecretary
        && this.procedureType != procedureTypeEnum.preventiveSettlement;
    },
  },
  watch: {},
  mounted() {
  },
  methods: { ...mapActions([]) },
};

</script>

<style lang="scss" scoped>
</style>
